import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskUser'
})
export class MaskUserPipe implements PipeTransform {
  transform(user: string): string {
    if (!user) return '';
    return user.length > 15 ? user.substring(0, 5) + '...' : user;
  }
}
